import "../../../css/Components/Pages/Dashboard/Dashboard.css";
import PortalCard from "../../../frontend/DesignSystem/Cards/PortalCard";
import Sidebar from "../../../frontend/DesignSystem/Sidebar";
import { Helmet } from "react-helmet-async";
import { PDFViewer } from "@react-pdf/renderer";
import TaxGuide from "./WhiteLabelledDocuments/TaxGuide/TaxGuide";
import { useEffect } from "react";
import generateAllTaxGuidesForAllAdvisers from "./WhiteLabelledDocuments/TaxGuide/HelperFunctions/generateAllTaxGuides";
import AnnualGuide from "./WhiteLabelledDocuments/AnnualGuide/AnnualGuide";
import generateAllGuidesForAllAdvisers from "./WhiteLabelledDocuments/AnnualGuide/HelperFunctions/getAllAnnualGuide";
import AnnualGuideV2 from "./WhiteLabelledDocuments/AnnualGuide/AnnualGuideV2";
import generateAllAnnualGuidesV2 from "./WhiteLabelledDocuments/AnnualGuide/HelperFunctions/getAllAnnualGuideV2";
// import { useEffect } from "react";
// import { auth } from "../../../firebase";
// import { useNavigate } from "react-router-dom";

/**
 * Dashboard component for the Members Hub section of the Adviser Portal.
 *
 * Renders a collection of PortalCard components, each linking to a different
 * section of the Members Hub, such as Mortgages, Protection & GI, Equity Release,
 * Financial Planning, Policy & Procedure Documents, User Guides & Links, Bulletins & Updates,
 * Customer Facing Material, Competent Adviser & Logging your CPD, Mortgage & Protection Business Resources,
 * Meet the Team, and Paraplanning Resources.
 *
 * The component also sets the page title and meta description using Helmet,
 * and includes a Sidebar for navigation.
 *
 * @component
 * @returns {JSX.Element} The rendered Dashboard component.
 */
const MembersHub= () => {
  // useEffect(() => {
  //   if (!auth.currentUser) {
  //     navigate("/");
  //   }

  // }, []);
  const TaxGuidePDF = (
    <TaxGuide
    // primaryColor={primaryColor}
    // logo={logo}
    // tradingName={tradingName}
    // regulatoryText={regulatoryText}
    // userEmail={userEmail}
    />
  );

  const annualGuide = (
    <AnnualGuide
    //  primaryColor={primaryColor}
    //  logo={logo}
    //  tradingName={tradingName}
    //  regulatoryText={regulatoryText}
    //  userEmail={userEmail}
    />
  );

  const annualGuideV2 = (
    <AnnualGuideV2
    //  primaryColor={primaryColor}
    //  logo={logo}
    //  tradingName={tradingName}
    //  regulatoryText={regulatoryText}
    //  userEmail={userEmail}
    />
  );

  // useEffect(() => {
  //   generateAllTaxGuidesForAllAdvisers();
  // }, []);
  // useEffect(() => {
  //   generateAllGuidesForAllAdvisers();
  // }, []);
  // useEffect(() => {
  //   generateAllAnnualGuidesV2();
  // }, []);

  return (
    <div className={`Dashboard-Content`}>
      <Helmet>
        <title>Members Hub</title>
        <meta
          name="description"
          content="Rosemount Financial Solutions (IFA) Ltd - Adviser Portal"
        />
      </Helmet>
      <Sidebar />
      {/* <PDFViewer width="100%" height="900px">
        {TaxGuidePDF}
      </PDFViewer> */}
      {/* <PDFViewer width="100%" height="900px">
        {annualGuide}
      </PDFViewer>  */}
      {/* <PDFViewer width="100%" height="900px">
        {annualGuideV2}
      </PDFViewer> */}
      <div className={`Dashboard-Container `}>
        <div className="Dashboard-Categories">
          <div id="intelliflo" className="Dashboard-Section">
            <PortalCard title="Intelliflo" link="/members-hub/Intelliflo" />
          </div>
          <div id="mortgages" className="Dashboard-Section">
            <PortalCard title="Mortgages" link="/members-hub/Mortgages" />
          </div>
          <div id="protection" className="Dashboard-Section">
            <PortalCard
              title="Protection & GI"
              link="/members-hub/Protection & GI"
            />
          </div>
          <div id="equity-release" className="Dashboard-Section">
            <PortalCard
              title="Equity Release"
              link="/members-hub/Equity Release"
            />
          </div>
          <div id="financial-planning" className="Dashboard-Section">
            <PortalCard
              title="Financial Planning"
              link="/members-hub/Financial Planning"
            />
          </div>
          <div id="policy-docs" className="Dashboard-Section">
            <PortalCard
              title="Policy & Procedure Documents"
              link="/members-hub/Policy & Procedure Documents"
            />
          </div>
          <div id="user-guides" className="Dashboard-Section">
            <PortalCard
              title="User Guides & Links"
              link="/members-hub/Useful Guides & Links"
            />
          </div>
          <div id="updates" className="Dashboard-Section">
            <PortalCard
              title="Bulletins & Updates"
              link="/members-hub/Bulletins & Updates"
            />
          </div>
          <div id="customer-material" className="Dashboard-Section">
            <PortalCard
              title="Customer Facing Material"
              link="/members-hub/Customer Facing Material"
            />
          </div>
          <div id="competent-adviser" className="Dashboard-Section">
            <PortalCard
              title="Competent Adviser & Logging your CPD"
              link="/members-hub/Competent Adviser & Logging your CPD"
            />
          </div>
          <div id="business-resources" className="Dashboard-Section">
            <PortalCard
              title="Mortgage & Protection Business Resources"
              link="/members-hub/Mortgage & Protection Business Resources"
            />
          </div>
          <div id="paraplanning" className="Dashboard-Section">
            <PortalCard
              title="Paraplanning Resources"
              link="/members-hub/Paraplanning Resources"
            />
          </div>
          <div id="meet-the-team" className="Dashboard-Section">
            <PortalCard
              title="Meet the Team"
              link="/members-hub/Meet the Team"
            />
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default MembersHub;
